import React, { useEffect, useState } from 'react';
import { Badge, Tooltip } from 'antd';
import { api } from 'react-structure-admin';
import { useSelector } from 'react-redux';
import { useSignalR } from './SignalRContext';
import { BellOutlined } from '@ant-design/icons';

const NotificationBadge = ({ onClick }) => {
  const [count, setCount] = useState(0);
  const { wasRead = false } =
    useSelector((c) => c.resources.notifications) ?? {};
  const { connection } = useSignalR();

  const getUnreadNotifications = () => {
    api.get('notifications', 'unread-notifications').then(({ data }) => {
      setCount(data?.result ?? 0);
    });
  };

  useEffect(() => {
    getUnreadNotifications();
  }, []);

  useEffect(() => {
    if (wasRead) {
      setCount(0);
    }
  }, [wasRead]);

  if (connection) {
    connection.on('ReceiveNotification', (notification) => {
      setCount(count + 1);
    });
  }

  return (
    <Tooltip title="Notificações">
      <Badge
        className="gx-ml-0 gx-mr-4 gx-pointer"
        count={count}
        offset={[-1, 10]}
        size="small"
        style={{
          fontSize: 9,
          minWidth: '15px',
          padding: '0 5px',
          boxShadow: 'none'
        }}
      >
        <BellOutlined
          style={{ marginTop: '0.3rem', fontSize: '20px', color: '#262626' }}
          icon="bell"
          onClick={onClick}
        />
      </Badge>
    </Tooltip>
  );
};

export default NotificationBadge;
